<script setup lang="ts">
defineEmits(['load-more-games']);

defineProps({
  pagination: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div
    v-if="pagination.total > 0"
    class="pagination"
  >
    <button
      class="btn-load-more"
      :disabled="pagination.currentPage === pagination.lastPage"
      @click="
        pagination.currentPage !== pagination.lastPage &&
        $emit('load-more-games')
      "
    >
      <span class="btn-text">
        {{
          pagination.currentPage !== pagination.lastPage
            ? 'Carregar mais jogos'
            : 'Mostrando'
        }}
      </span>
      <span class="btn-counter">
        {{ pagination.to }} de {{ pagination.total }}
      </span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.pagination {
  @apply w-full pt-2 mb-4 flex justify-center items-center xl:mb-14;

  .btn-load-more {
    display: flex;
    width: 100%;
    height: 40px;
    padding: 7px 15px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 9px;
    border: 1px solid var(--accent-color, #2d2dff);
    background: color-mix(in srgb, var(--accent-color, #0a0a77) 40%, black);
    outline: none;
    transition: all 0.3s;

    &:disabled {
      cursor: default;
      opacity: 0.8;
    }

    &:hover:not(:disabled) {
      border-color: color-mix(in srgb, var(--accent-color, #4d4dff) 80%, white);
      box-shadow: 0 0 20px
        color-mix(in srgb, var(--accent-color, #2d2dff) 50%, transparent);
    }

    .btn-text {
      color: white;
      font-size: 12px;
      font-weight: 600;
      line-height: 110%;
    }

    .btn-counter {
      display: flex;
      padding: 5px 11px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 100px;
      background: rgba(0, 0, 0, 0.3);
      color: white;
      font-size: 12px;
      font-weight: 600;
      line-height: 110%;
    }
  }
}
</style>
